jQuery.noConflict();
(function( $ ) {
    $(function() {
        //Document Ready STARTS
        setTimeout(initGa, 2000);
        function initGa(){

            // JOB category Click
            $('body').on('click', '#hj-select-sector ul li > a', function(e){
                var link = $(this).attr('href'),
                    title = $(this).attr('title');
                if (window.dataLayer != undefined) {
                    window.dataLayer.push({
                        'event' : 'JobCategoryClick',
                        'menu_item_name' : title,
                        'menu_item_url' : link,
                        eventCategory: 'custom',
                        eventAction: 'click',
                        eventLabel: 'JobCategoryClick'
                    });
                }
                else if ( typeof(gtag) != 'undefined' ) {
                    gtag('event', 'JobCategoryClick', {
                        'event_category' : 'vacancies',
                        'event_label' : title
                    });
                }
              //  console.log('JobCategoryClick: '+title + ' => '+link);
            });

            // Single Job Click
            $('body').on('click', '#hj-job-list ol li > a', function(e) {
                var link = $(this).attr('href'),
                    title = $(this).attr('title');
                if (window.dataLayer != undefined) {
                    window.dataLayer.push({
                        'event' : 'JobClick',
                        'menu_item_name' : title,
                        'menu_item_url' : link,
                        eventCategory: 'custom',
                        eventAction: 'click',
                        eventLabel: 'JobClick'
                    });
                }
                else if ( typeof(gtag) != 'undefined' ) {
                    gtag('event', 'JobClick', {
                        'event_category' : 'vacancies',
                        'event_label' : title
                    });
                }
              //  console.log('JobClick: '+title + ' => '+link);
            });

            $('body').on('click', '#hj-job a.hj-apply-online', function(e) {
                e.preventDefault();
                var link = $(this).attr('href'),
                    title = $('.hj-job-title h2').text();
                if (window.dataLayer != undefined) {
                    window.dataLayer.push({
                        'event' : 'JobApply',
                        'menu_item_name' : title,
                        'menu_item_url' : link,
                        eventCategory: 'custom',
                        eventAction: 'click',
                        eventLabel: 'JobApply'
                    });
                }
                else if ( typeof(gtag) != 'undefined' ) {
                    gtag('event', 'JobApply', {
                        'event_category' : 'vacancies',
                        'event_label' : title
                    });
                }
               // console.log('JobApply: '+title + ' => '+link);
                window.open(link, "_blank");
            });
        }
        //Document Ready ENDS
    });
})(jQuery);